/**
 * wb-currency.js — ตัวแปลงสกุลเงินแบบแสดงผล (display-only)
 *
 * ร้านตัดเงินจริงเป็น THB เสมอ (ยังไม่ได้เปิด Shopify Payments multi-currency)
 * ไฟล์นี้แค่แปลง "ตัวเลขที่ลูกค้าเห็น" บนหน้าเว็บ เหมือนแอป currency converter ทั่วไป
 *
 * config มาจาก snippets/wb-currency.liquid ผ่าน window.WB_CURRENCY_CONFIG
 */
(function () {
  'use strict';

  var CFG = window.WB_CURRENCY_CONFIG || {};
  var BASE = (CFG.shopCurrency || 'THB').toUpperCase();
  var LOCALE = CFG.locale === 'th' ? 'th-TH' : 'en-US';
  var STORE_KEY = 'wb_currency';
  var COUNTRY_KEY = 'wb_currency_country';
  var RATES_KEY = 'wb_currency_rates';
  var RATES_TTL = 12 * 60 * 60 * 1000; // 12 ชม.

  // สกุลเงินตามคอลัมน์ CURRENCY ในตารางค่าขนส่ง (+ THB ต้นทาง)
  var CURRENCIES = CFG.currencies || [
    'THB', 'JPY', 'CNY', 'TWD', 'HKD', 'KRW', 'SGD', 'PHP', 'VND', 'MYR',
    'USD', 'CAD', 'NZD', 'AUD', 'EUR', 'GBP', 'RUB',
  ];

  // สัญลักษณ์ + ชื่อ (ไทย/อังกฤษ) ของแต่ละสกุล — ใช้ทำเมนูให้อ่านง่ายกว่าโชว์แค่รหัส
  // สัญลักษณ์เขียนเองไม่ใช้ของ Intl เพราะหลายสกุลได้ "$" เหมือนกันหมดจนแยกไม่ออก
  var META = {
    THB: ['฿', 'บาท', 'Thai Baht'],
    JPY: ['¥', 'เยน', 'Japanese Yen'],
    CNY: ['CN¥', 'หยวน', 'Chinese Yuan'],
    TWD: ['NT$', 'ดอลลาร์ไต้หวัน', 'Taiwan Dollar'],
    HKD: ['HK$', 'ดอลลาร์ฮ่องกง', 'Hong Kong Dollar'],
    KRW: ['₩', 'วอน', 'Korean Won'],
    SGD: ['S$', 'ดอลลาร์สิงคโปร์', 'Singapore Dollar'],
    PHP: ['₱', 'เปโซ', 'Philippine Peso'],
    VND: ['₫', 'ดอง', 'Vietnamese Dong'],
    MYR: ['RM', 'ริงกิต', 'Malaysian Ringgit'],
    USD: ['$', 'ดอลลาร์สหรัฐ', 'US Dollar'],
    CAD: ['C$', 'ดอลลาร์แคนาดา', 'Canadian Dollar'],
    NZD: ['NZ$', 'ดอลลาร์นิวซีแลนด์', 'New Zealand Dollar'],
    AUD: ['A$', 'ดอลลาร์ออสเตรเลีย', 'Australian Dollar'],
    EUR: ['€', 'ยูโร', 'Euro'],
    GBP: ['£', 'ปอนด์', 'British Pound'],
    RUB: ['₽', 'รูเบิล', 'Russian Ruble'],
  };

  // จัดกลุ่มตาม REGION เดียวกับโซนค่าส่ง จะได้สอดคล้องกันทั้งร้าน
  var GROUPS = [
    ['', ['THB']],
    ['เอเชีย|Asia', ['JPY', 'CNY', 'TWD', 'HKD', 'KRW', 'SGD', 'PHP', 'VND', 'MYR']],
    ['อเมริกาเหนือ|North America', ['USD', 'CAD']],
    ['โอเชียเนีย|Oceania', ['NZD', 'AUD']],
    ['ยุโรป|Europe', ['EUR', 'GBP', 'RUB']],
  ];

  function isTH() { return CFG.locale === 'th'; }
  function label(code) { return (META[code] || ['', code, code])[isTH() ? 1 : 2]; }
  function symbol(code) { return (META[code] || [code])[0]; }
  function groupName(pair) {
    if (!pair) return '';
    var p = pair.split('|');
    return isTH() ? p[0] : p[1];
  }

  // ประเทศ -> สกุลเงิน ตามคอลัมน์ CURRENCY ในตารางเดียวกัน
  // ใช้ผูกปุ่มนี้เข้ากับตัวเลือกประเทศของ Shopify: เปลี่ยนประเทศ = สกุลเงินวิ่งตาม
  var COUNTRY_CURRENCY = {
    TH: 'THB', JP: 'JPY', CN: 'CNY', TW: 'TWD', HK: 'HKD', KR: 'KRW',
    SG: 'SGD', PH: 'PHP', VN: 'VND', MY: 'MYR', US: 'USD', CA: 'CAD',
    NZ: 'NZD', AU: 'AUD', GB: 'GBP', RU: 'RUB',
    IE: 'EUR', FR: 'EUR', IT: 'EUR', ES: 'EUR', DE: 'EUR',
  };
  var COUNTRY = (CFG.country || '').toUpperCase();

  // ธีมโชว์ราคาได้หลายรูปแบบ ต้องจับให้ครบทั้ง 3:
  //   "790.00 ฿" · "790.00 THB" (money / money_with_currency)
  //   "฿790.00" · "THB ฿1,670.00" (สัญลักษณ์นำหน้า)
  var NUM = '\\d{1,3}(?:,\\d{3})*(?:\\.\\d+)?|\\d+(?:\\.\\d+)?';
  var MONEY_RE = new RegExp(
    '(?:THB\\s*)?฿\\s*(' + NUM + ')' + '|' + '(' + NUM + ')\\s*(?:฿|THB\\b)',
    'g'
  );

  var rates = null;
  var current = BASE;

  /* ---------- rates ---------- */

  function cachedRates() {
    try {
      var raw = localStorage.getItem(RATES_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.at || Date.now() - o.at > RATES_TTL) return null;
      if (o.base !== BASE) return null;
      return o.rates;
    } catch (e) {
      return null;
    }
  }

  function storeRates(r) {
    try {
      localStorage.setItem(RATES_KEY, JSON.stringify({ at: Date.now(), base: BASE, rates: r }));
    } catch (e) {
      /* โควตาเต็ม/ปิด storage — ข้ามได้ ไม่ critical */
    }
  }

  // สองแหล่ง ฟรีทั้งคู่ ไม่ต้องใช้ API key และเปิด CORS
  function fetchRates() {
    var lower = BASE.toLowerCase();
    var primary = 'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/' + lower + '.json';
    var fallback = 'https://open.er-api.com/v6/latest/' + BASE;

    return fetch(primary)
      .then(function (r) {
        if (!r.ok) throw new Error('primary ' + r.status);
        return r.json();
      })
      .then(function (j) {
        var src = j[lower];
        if (!src) throw new Error('primary shape');
        var out = {};
        CURRENCIES.forEach(function (c) {
          var v = src[c.toLowerCase()];
          if (typeof v === 'number') out[c] = v;
        });
        out[BASE] = 1;
        return out;
      })
      .catch(function () {
        return fetch(fallback)
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var out = {};
            CURRENCIES.forEach(function (c) {
              if (j.rates && typeof j.rates[c] === 'number') out[c] = j.rates[c];
            });
            out[BASE] = 1;
            return out;
          });
      });
  }

  function ensureRates() {
    var c = cachedRates();
    if (c) {
      rates = c;
      return Promise.resolve(c);
    }
    return fetchRates().then(function (r) {
      rates = r;
      storeRates(r);
      return r;
    });
  }

  /* ---------- format ---------- */

  // ต่อท้ายด้วยรหัสสกุลเงินเสมอ เพราะหลายสกุลใช้สัญลักษณ์ซ้ำกัน
  // (USD/SGD/HKD/TWD/CAD/NZD/AUD = "$" เหมือนกันหมด) -> "$53.21 USD" แบบเว็บ ref
  function format(amount, code) {
    var num;
    try {
      num = new Intl.NumberFormat(LOCALE, {
        style: 'currency',
        currency: code,
        currencyDisplay: 'narrowSymbol',
      }).format(amount);
    } catch (e) {
      try {
        num = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: code }).format(amount);
      } catch (e2) {
        num = amount.toFixed(2);
      }
    }
    return num.indexOf(code) === -1 ? num + ' ' + code : num;
  }

  /* ---------- แปลงข้อความในหน้า ---------- */

  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1, SELECT: 1, OPTION: 1 };

  function walk(fn) {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var p = node.parentNode;
        if (!p || SKIP_TAGS[p.nodeName]) return NodeFilter.FILTER_REJECT;
        if (p.closest && p.closest('[data-wb-currency-skip]')) return NodeFilter.FILTER_REJECT;
        // ยังไม่เคยแปลง แล้วไม่มีเลขเงินอยู่เลย -> ข้าม
        if (node.__wbOrig === undefined && node.nodeValue.indexOf('฿') === -1
            && node.nodeValue.indexOf('THB') === -1) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    });
    var n, list = [];
    while ((n = w.nextNode())) list.push(n);
    list.forEach(fn);
  }

  function applyTo(node) {
    // เก็บข้อความต้นฉบับไว้ครั้งแรก แล้วแปลงจากต้นฉบับเสมอ (กันแปลงซ้อน)
    if (node.__wbOrig === undefined) node.__wbOrig = node.nodeValue;
    var orig = node.__wbOrig;

    if (current === BASE || !rates || !rates[current]) {
      if (node.nodeValue !== orig) node.nodeValue = orig;
      return;
    }

    var rate = rates[current];
    var next = orig.replace(MONEY_RE, function (whole, pre, post) {
      var num = pre !== undefined ? pre : post;
      var v = parseFloat(String(num).replace(/,/g, ''));
      if (!isFinite(v)) return whole;
      return format(v * rate, current);
    });
    if (node.nodeValue !== next) node.nodeValue = next;
  }

  var observer = null;
  var pending = false;

  function convert() {
    // ปลด observer ก่อนแตะ DOM — ทั้งการเติมปุ่มและการเขียนตัวเลขใหม่จึงไม่วน
    // กลับมาปลุก scheduleConvert() ซ้ำ (disconnect() ล้างคิว record ให้ด้วย)
    if (observer) observer.disconnect();
    try {
      // ตะกร้าเรนเดอร์ใหม่ = ปุ่มในตะกร้าหายไปด้วย เติมกลับตรงนี้ทุกรอบ
      mountPlaceholders();
      walk(applyTo);
      // ต้องอยู่ในวงเล็บนี้ด้วย: syncLabel() เขียน textContent ซึ่งนับเป็น
      // childList mutation แม้ค่าจะเท่าเดิม ถ้าปล่อยไว้นอก finally มันจะปลุก
      // observer -> scheduleConvert -> convert -> syncLabel วนทุกเฟรมไม่จบ
      syncLabel();
    } finally {
      if (observer) {
        observer.observe(document.body, { childList: true, subtree: true, characterData: true });
      }
    }
  }

  function scheduleConvert() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      convert();
    });
  }

  /* ---------- UI ---------- */

  // มีปุ่มได้หลายตัวพร้อมกัน (header + ในเมนูแฮมเบอร์เกอร์ + ในตะกร้า)
  var roots = [];

  // เขียนเมื่อค่าต่างจริงเท่านั้น — กันไม่ให้ syncLabel() ปั่น mutation เปล่า ๆ
  // ทุกครั้งที่ถูกเรียก (ดูเหตุผลเต็มในคอมเมนต์ของ convert())
  function setText(node, value) {
    if (node.textContent !== value) node.textContent = value;
  }

  function syncLabel() {
    document.querySelectorAll('[data-wb-currency-symbol]').forEach(function (n) {
      setText(n, symbol(current));
    });
    document.querySelectorAll('[data-wb-currency-label]').forEach(function (n) {
      setText(n, current);
    });
    document.querySelectorAll('[data-wb-currency-option]').forEach(function (b) {
      b.setAttribute('aria-selected', b.dataset.wbCurrencyOption === current ? 'true' : 'false');
    });
  }

  function select(code) {
    current = code;
    try { localStorage.setItem(STORE_KEY, code); } catch (e) { /* ignore */ }
    if (code !== BASE && !rates) {
      ensureRates().then(convert).catch(function () { current = BASE; convert(); });
    } else {
      convert();
    }
    closeMenu();
  }

  function closeRoot(root) {
    root.classList.remove('is-open');
    var btn = root.querySelector('[data-wb-currency-toggle]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function closeMenu() {
    roots.forEach(closeRoot);
  }

  function buildOne(tpl) {
    var root = tpl.content.firstElementChild.cloneNode(true);

    var list = root.querySelector('[data-wb-currency-list]');
    GROUPS.forEach(function (g) {
      var codes = g[1].filter(function (c) { return CURRENCIES.indexOf(c) !== -1; });
      if (!codes.length) return;

      var head = groupName(g[0]);
      if (head) {
        var h = document.createElement('li');
        h.className = 'wb-currency__group';
        h.setAttribute('role', 'presentation');
        h.textContent = head;
        list.appendChild(h);
      }

      codes.forEach(function (code) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'wb-currency__option';
        b.dataset.wbCurrencyOption = code;
        b.setAttribute('role', 'option');

        b.innerHTML =
          '<span class="wb-currency__sym"></span>' +
          '<span class="wb-currency__name"></span>' +
          '<span class="wb-currency__code"></span>' +
          '<svg class="wb-currency__check" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
          '<path d="M3.5 8.5L6.5 11.5L12.5 5" stroke="currentColor" stroke-width="1.8"' +
          ' stroke-linecap="round" stroke-linejoin="round"/></svg>';
        b.querySelector('.wb-currency__sym').textContent = symbol(code);
        b.querySelector('.wb-currency__name').textContent =
          code === BASE ? label(code) + ' · ' + (CFG.baseLabel || '') : label(code);
        b.querySelector('.wb-currency__code').textContent = code;

        b.addEventListener('click', function () { select(code); });
        li.appendChild(b);
        list.appendChild(li);
      });
    });

    root.querySelector('[data-wb-currency-toggle]').addEventListener('click', function (e) {
      e.stopPropagation();
      var open = root.classList.toggle('is-open');
      this.setAttribute('aria-expanded', open ? 'true' : 'false');
      // เปิดตัวไหน ปิดตัวที่เหลือ (มีปุ่มสองที่: header กับในเมนูแฮมเบอร์เกอร์)
      if (open) roots.forEach(function (r) { if (r !== root) closeRoot(r); });
      if (open && !rates) ensureRates().then(convert).catch(function () {});
    });

    return root;
  }

  /**
   * เติมปุ่มลง "ที่จอด" ทุกอันที่ยังว่าง — ที่จอดคือ [data-wb-currency-mount]
   * ที่ Liquid วางไว้ (ตอนนี้มีที่เดียว: แถวสรุปยอดในตะกร้า snippets/cart-summary.liquid)
   *
   * ที่ต้องเรียกซ้ำได้ เพราะตะกร้าถูกเรนเดอร์ใหม่ทั้งก้อนผ่าน Section Rendering API
   * ทุกครั้งที่ลูกค้าแก้จำนวน/ลบสินค้า ปุ่มที่เราแทรกไว้จะหายไปกับ HTML ชุดเก่า
   * convert() จึงเรียกฟังก์ชันนี้ทุกรอบ (ตัวมันวิ่งอยู่แล้วทุกครั้งที่ DOM ขยับ)
   * ค่าของ attribute จะกลายเป็น modifier class เช่น mount="cart" -> .wb-currency--cart
   */
  function mountPlaceholders() {
    var tpl = document.getElementById('wb-currency-template');
    if (!tpl) return;

    // ทิ้ง root ที่หลุดออกจากหน้าไปแล้ว ไม่งั้น roots บวมขึ้นทุกครั้งที่ตะกร้าอัปเดต
    roots = roots.filter(function (r) { return document.contains(r); });

    document.querySelectorAll('[data-wb-currency-mount]').forEach(function (slot) {
      if (slot.querySelector('[data-wb-currency]')) return;
      var root = buildOne(tpl);
      root.classList.add('wb-currency--' + (slot.getAttribute('data-wb-currency-mount') || 'inline'));
      slot.appendChild(root);
      roots.push(root);
    });
  }

  function buildUI() {
    var tpl = document.getElementById('wb-currency-template');
    if (!tpl) return;

    // จอคอม: ข้างปุ่มเลือกภาษาบน header (ไม่มีก็ไล่หาที่อื่นในคอลัมน์ขวา)
    var headerAnchor = document.querySelector('.dropdown-localization')
      || document.querySelector('.localization-selector')
      || document.querySelector('.header__column--right')
      || document.querySelector('.header-actions');
    if (headerAnchor) {
      var headerRoot = buildOne(tpl);
      // ติดคลาสแยกไว้ เพราะเมนูแฮมเบอร์เกอร์ก็อยู่ใน .header__columns เหมือนกัน
      // ถ้าเลือกด้วย .header__columns .wb-currency เฉย ๆ จะโดนตัวในลิ้นชักด้วย
      headerRoot.classList.add('wb-currency--header');
      if (headerAnchor.classList.contains('dropdown-localization')
          || headerAnchor.classList.contains('localization-selector')) {
        headerAnchor.parentNode.insertBefore(headerRoot, headerAnchor.nextSibling);
      } else {
        headerAnchor.insertBefore(headerRoot, headerAnchor.firstChild);
      }
      roots.push(headerRoot);
    }

    // มือถือ: ต่อท้ายแถบ utility ในเมนูแฮมเบอร์เกอร์ ใต้ตัวเลือกภาษาของธีม
    var drawerAnchor = document.querySelector('.menu-drawer__utility-links');
    if (drawerAnchor) {
      var drawerRoot = buildOne(tpl);
      drawerRoot.classList.add('wb-currency--drawer');
      drawerAnchor.appendChild(drawerRoot);
      roots.push(drawerRoot);
    }

    // ตะกร้า (ลิ้นชัก + หน้า /cart) และที่จอดอื่น ๆ ที่ Liquid วางไว้
    mountPlaceholders();

    if (!roots.length) return;

    document.addEventListener('click', function (e) {
      roots.forEach(function (r) { if (!r.contains(e.target)) closeRoot(r); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  /* ---------- start ---------- */

  // ครั้งแรกที่เข้า หรือทุกครั้งที่ลูกค้าเปลี่ยนประเทศ -> สกุลเงินวิ่งตามประเทศ
  // ถ้าลูกค้าเลือกสกุลเงินเองทีหลัง ค่านั้นจะอยู่จนกว่าจะเปลี่ยนประเทศอีกครั้ง
  function resolveInitial() {
    var picked = null, lastCountry = null;
    try {
      picked = localStorage.getItem(STORE_KEY);
      lastCountry = localStorage.getItem(COUNTRY_KEY);
    } catch (e) { /* storage ปิดอยู่ */ }

    var byCountry = COUNTRY_CURRENCY[COUNTRY];
    var next = picked;
    if (!picked || (COUNTRY && lastCountry !== COUNTRY)) {
      next = byCountry || BASE;
    }
    if (CURRENCIES.indexOf(next) === -1) next = BASE;

    try {
      localStorage.setItem(STORE_KEY, next);
      if (COUNTRY) localStorage.setItem(COUNTRY_KEY, COUNTRY);
    } catch (e) { /* ignore */ }
    return next;
  }

  function init() {
    current = resolveInitial();

    buildUI();
    syncLabel();

    observer = new MutationObserver(scheduleConvert);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });

    if (current !== BASE) {
      ensureRates().then(convert).catch(function () { current = BASE; syncLabel(); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
